module.exports = __webpack_public_path__ + "images/gameMain01.png?2b30914b6ebf30b0c4662824049cfd3e";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameMain01.png
// module id = 91
// module chunks = 0